import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './../firebase-config';
import Courses from '../components/Home/Courses';
import IntroSection from '../components/Home/IntroSection';
import ResumeSection from '../components/Home/ResumeSection';
import Spinner from './../components/Spinner';

export default function Home() {
  const [homeData, setHomeData] = useState(null);
  const homeDocRef = doc(db, 'website-data', 'home-data');

  const getHomeData = async () => {
    const data = await getDoc(homeDocRef);
    setHomeData(data.data());
  };

  console.log(homeData);

  useEffect(() => {
    document.title = 'Dr. Nithin M';
    getHomeData();
  }, []);

  return (
    <>
      {homeData ? (
        <>
          <IntroSection homeData={homeData} />
          <ResumeSection homeData={homeData} />
          <Courses homeData={homeData} />
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
}
